<template>
  <div class="modal_content">
    <div class="title_label">
      {{titleLabel}}
    </div>
    <div class="corporation_info_label detail_label" v-text='valueLabel'>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleLabel: String,
    valueLabel: String
  },
  data () {
    return {
    }
  }
}
</script>
<style scoped>
.title_label {
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/modalWindow/modalwindowComponents/valueLabelSection.vue